import ThemeContext from "config/context/themeContext";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import styles from "./MainLayout.module.css";
import { Aside, MainNavbar, MainSidebar } from "features/navigation";
import { DatabaseStructureFetcher } from "features/compositions";
import { CompositionsContextProvider } from "features/compositions/context/CompositionsContext";
import ModalRenderer from "components/shared/modal/ModalRenderer.jsx";

const MainLayout = () => {
  const { dark: isDark } = useContext(ThemeContext);

  return (
    <CompositionsContextProvider>
      <div className={`${styles.mainLayout} ${isDark ? "dark" : "light"}`}>
        {/* <Aside /> */}
        <DatabaseStructureFetcher />
        <MainNavbar />
        <MainSidebar />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
      <ModalRenderer />
    </CompositionsContextProvider>
  );
};

export default MainLayout;
